import { useDispatch, useSelector } from 'react-redux';
import type { RootState } from '../store/store';
import { setConfig } from '../store/slices/appSlice';
import type { OrgConfig } from '../types/orgConfig';

export const useAppConfig = () => {
    const dispatch = useDispatch();

    // Safely get config from Redux slice, or fallback to returning null properties
    const config = useSelector((state: RootState) => state.app.config) as OrgConfig | null;

    const updateConfig = (newConfig: OrgConfig | null) => {
        dispatch(setConfig(newConfig));
    };

    const root = document.documentElement;

    return {
        config,
        updateConfig,
        themeColors: {
            btnColor: config?.btnColor ?? root.style.getPropertyValue('--primary-color'),
            textColor: config?.textColor ?? root.style.getPropertyValue('--primary-text-color'),
            btnTextColor: config?.btnTextColor ?? root.style.getPropertyValue('--white-color'),
            bgColor: config?.bgColor ?? root.style.getPropertyValue('--primary-bg-color'),
        },
        // Useful derived specific configurations
        visitorTypes: config?.visitorType ?? [],
        orgId: config?.orgId ?? '',
        siteId: config?.siteId ?? '',
        siteName: config?.siteName ?? '',
        orgName: config?.orgName ?? '',
    };
};
